// extracted by mini-css-extract-plugin
export default {"home-link":"tg8ee","logo":"RA1_x","logo-text":"in59j","white":"kwTsI","black":"QkafX","center":"H2fG3","pointer-event-none":"qizXY","logo-text-header":"dykHb"};